import React, { useEffect, useState } from "react";
import { useObserver } from "mobx-react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useStores } from "../../store";
import {
  MdCheckCircleOutline,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import { toJS } from "mobx";
import { IoCloseCircleOutline } from "react-icons/io5";
export default function InterviewPopup(props) {
  const { PopupStore, UserStore, RecuiterStore } = useStores();
  const navigate = useNavigate();
  const [form, setform] = useState(false);
  const [fileName1, setFileName1] = useState("");
  const [url, seturl] = useState("");
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    console.log(toJS(RecuiterStore.job));
  }, [RecuiterStore.job]);

  const closeThisPopUP = () => {
    setform(false);
    setFileName1("");
    seturl("");
    PopupStore.setInterview(false);
  };

  return useObserver(() => (
    <>
      {PopupStore.interview ? (
        <div
          onClick={closeThisPopUP}
          className="fixed w-full h-[100%] z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[65%] lg:w-[60%] w-[90%] h-[75%] md:h-[60] lg:h-[50%] m-auto shadow-lg overflow-y-auto no-scrollbar"
          >
            <div className=" flex flex-col justify-start my-[10%] gap-8 items-center  h-full py-5 w-[100%] md:w-[100%] lg:[100%]  ">
              <Loader loader={loader} />
              <AiFillCloseCircle
                className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
              <div className=" flex flex-col gap-6 w-[90%]">
                <h1 className="font-bold w-[90%] text-xl">Interview Details</h1>

                <div className="w-[90%] grid grid-cols-2 gap-4">
                  <div className="border-l-2 pl-2 border-primary">
                    <span className="font-semibold text-[#747474] ">
                      Name of interview:{" "}
                    </span>
                    <span className="text-primary font-semibold">
                      {RecuiterStore.job?.technology}
                    </span>
                  </div>
                  <div
                    className="border-l-2 pl-2 border-primary"
                    onClick={() => console.log(toJS(RecuiterStore.job))}
                  >
                    <span className="font-semibold text-[#747474] ">
                      Type of interview:{" "}
                    </span>
                    <span className="text-primary font-semibold">
                      {/* {RecuiterStore.job?.interviewId === "11" ||
                      RecuiterStore.job?.interviewId === "12"
                        ? "Manual Interview"
                        : "AI Interview"} */}
                      {RecuiterStore.job?.interviewType === "real"
                        ? "Manual Interview"
                        : "AI Interview"}
                    </span>
                  </div>
                  <div className="border-l-2 pl-2 border-primary">
                    <span className="font-semibold text-[#747474] ">
                      Difficulty Level:{" "}
                    </span>
                    <span className="text-primary font-semibold">
                      {RecuiterStore.job?.levelOfInterview}
                    </span>
                  </div>
                  <div className="border-l-2 pl-2 border-primary">
                    <span className="font-semibold text-[#747474] ">
                      No.of Questions:{" "}
                    </span>
                    <span className="text-primary font-semibold">
                      {RecuiterStore.job?.noOfQuestions}
                    </span>
                  </div>
                  <div className="border-l-2 pl-2 border-primary">
                    <span className="font-semibold text-[#747474] ">
                      Added Custom Questions:{" "}
                    </span>
                    <span className="text-primary font-semibold">
                      {RecuiterStore.job?.customQuestions?.length >= 1
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="w-[90%]">
                <h1 className="font-bold w-[90%] text-xl">
                  Your Custom Questions:{" "}
                </h1>
                <ol>
                  {RecuiterStore.job?.customQuestions?.map((e, key) => {
                    return (
                      <li className="font-semibold text-[#747474] ">
                        {key + 1}. {e}
                      </li>
                    );
                  })}
                  {RecuiterStore.job?.customQuestions?.length === 0 && (
                    <h1 className="font-bold text-[#747474] flex justify-center py-4 w-[90%] text-xl">
                      No Custom Questions
                    </h1>
                  )}
                </ol>
              </div>
              <div className="w-[90%]">
                <h1 className="font-bold w-[90%] text-xl">
                  Interview Settings
                </h1>

                <div className="flex gap-4 py-4">
                  {RecuiterStore.job?.customSettings
                    .filter((e) => e.name !== "attempts")
                    .map((e) => (
                      <div
                        key={e.name} // Add a unique key for each element in the list
                        className={`border-2 ${
                          e.value ? "border-primary" : "border-[#747474]"
                        } px-4 w-fit font-medium rounded-xl flex p-2 gap-2 items-center justify-center`}

                        // className={`border-2 ${ e.value ==="true" ? " border-primary ":"border-[#747474]"}  px-4 w-fit font-medium rounded-xl flex p-2 gap-2 items-center justify-center`}
                      >
                        <p>{e.name}
                        {e.name === "proxy" && (
                      <span className="ml-1 px-2 py-1 text-[8px] bg-blue-100 text-blue-600 rounded-full">BETA</span>
                    )}
                        </p>
                        {e.value ? (
                          <MdCheckCircleOutline color="green" />
                        ) : (
                          <IoCloseCircleOutline color="red" />
                        )}
                      </div>
                    ))}
                </div>

                {RecuiterStore.job?.customSettings?.length === 0 && (
                  <div className="flex py-4 gap-4">
                    <div className=" border-2 border-[#747474] px-4 w-fit font-medium rounded-xl flex p-2 gap-2 items-center justify-center ">
                      <p>Video</p>
                      <IoCloseCircleOutline color="red" />
                    </div>
                    <div className=" border-2 border-[#747474] px-4 w-fit font-medium rounded-xl flex p-2 gap-2 items-center justify-center ">
                      <p>Resume</p>
                      <IoCloseCircleOutline color="red" />
                    </div>
                    <div className=" border-2 border-[#747474] px-4 w-fit font-medium rounded-xl flex p-2 gap-2 items-center justify-center ">
                      <p>Screen Recording</p>
                      <IoCloseCircleOutline color="red" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
